// Helper to fetch Flexmonster license key from Firebase Function
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebaseConfig.js";

const getFlexmonsterLicense = httpsCallable(functions, "getFlexmonsterKey");

export async function fetchFlexmonsterLicenseKey() {
  const flexmonsterKey = await getFlexmonsterLicense();
  if (!flexmonsterKey || !flexmonsterKey.data || !flexmonsterKey.data.licenseKey) {
    throw new Error("Flexmonster license key not found in response");
  }
  return flexmonsterKey.data.licenseKey;
}
